/**
 * @author: yanhoup
 * @description: table组件(基于fusionTable上扩展，兼容Table组件的api)
 */
import $i18n from 'panda-i18n';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Checkbox, Dialog, Table } from '@fpxfd/next';
import { FpxTableProps, GroupItem, State, TableChild } from './index.inerface';
import { transformMap } from '@/utils/transformMap';
import { useSetState } from 'ahooks';
import styles from './index.module.scss';
import { findDOMNode } from 'react-dom';

const widthProps = {
  warehouseCode: 240,
  fromWarehouseCode: 240,
  warehouse: 240,
  createTime: 200,
  beginTime: 200,
  endTime: 200,
  complteTime: 200,
  compeletTime: 200,
  completeTime: 200,
  operationTime: 200,
  updateTime: 200,
  operationStartTime: 200,
  approveTime: 200,
  operationEndTime: 200,
  createJobTime: 200,
  auditTime: 200,
  arriveTime: 200,
  unloadFinishTime: 200,
  receiveFinishTime: 200,
  putawayFinishTime: 200,
  startTime: 200,
  finishTime: 200,
  actualDate: 200,
  appointmentReceiveDate: 200,
  actualArriveDate: 200,
  planPutawayDate: 200,
  expiryDate: 150,
  receiveTime: 200,
  containerNo: 200,
  jobDetailNo: 240,
  jobNo: 200,
  consignmentNo: 240,
  pickNo: 240,
  waveNo: 240,
  agvNo: 240,
  rtaskNo: 240,
  time: 200,
  expectPutawayDate: 200,
};

const { Group } = Checkbox;

const FpxTable = ({ children, isTableSetting = true, stickyHeader = false, ...lastProps }: FpxTableProps) => {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const emptyContent = <img src={require('../../assets/images/table-empty.svg')} alt="example" width="100" />;

  const [scrollToRow, setScrollToRow] = useState(0);

  const ref = useRef(null);

  let newprops = { ...lastProps };

  // 虚拟滚动
  if (lastProps.useVirtual) {
    newprops = {
      ...newprops,
      scrollToRow,
      onBodyScroll: (value) => setScrollToRow(value),
      maxBodyHeight: 600 || newprops.maxBodyHeight,
    };
  }

  useEffect(() => {
    // 在tab 切换的时候table transformY值没有变化 导致ui上出现错位 这里让滚动区滚动一点点 来重新计算位置
    if (lastProps.useVirtual) {
      if (ref.current) {
        const node = findDOMNode(ref.current);
        const scrollView = node.querySelector('.next-table-body');
        scrollView.scrollTo({
          behavior: 'smooth',
          top: scrollView.scrollTop - 1 || 0,
        });
      }
    }
  }, [lastProps.dataSource]);

  const [state, setState] = useSetState<State>({
    child: [],
    groupKeys: [],
    selectKeys: [],
    oldSelectKeys: [],
    visible: false,
    hasAction: false,
    isDetailPage: false,
    isInbound: false,
    originChildren: [],
  });

  useEffect(() => {
    const isFirst = state.selectKeys.length === 0;
    const arr: GroupItem[] = [];
    const nowChilds = (children! as TableChild[]).map((e) => {
      if (!e) return e;
      const { props } = e;
      const { cell, dataIndex, width, isCover, title, isCellCover } = props;
      const data = {
        label: title,
        value: dataIndex,
      };
      arr.push(data);
      return {
        ...e,
        show: isFirst ? true : state.selectKeys.includes(e.props.dataIndex),
        props: {
          ...props,
          cell: !isCellCover && transformMap[dataIndex] ? transformMap[dataIndex] : cell,
          width: !isCover && widthProps[dataIndex] ? widthProps[dataIndex] : width,
        },
      };
    });
    const isInbound = window.location.pathname.includes('/inbound/');
    const hasAction = !!document.querySelector('.action-bar');
    const isDetailPage = !!document.querySelector('.fpx-detail');
    setState({
      child: nowChilds,
      hasAction,
      isDetailPage,
      isInbound,
    });
    if (isInbound && !isDetailPage) {
      setState({
        groupKeys: arr,
        selectKeys: isFirst ? arr.map((e) => e.value) : state.selectKeys,
        oldSelectKeys: isFirst ? arr.map((e) => e.value) : state.selectKeys,
      });
    }
  }, [children]);

  const onSelectionchange = useCallback(
    (value) => {
      setState({ selectKeys: value });
    },
    [setState],
  );

  const doOk = useCallback(() => {
    const { selectKeys, child } = state;
    const newChild = child.map((e) => ({ ...e, show: selectKeys.includes(e.props.dataIndex) }));
    setState({
      child: newChild,
      visible: false,
      oldSelectKeys: selectKeys,
    });
  }, [state, setState]);

  const renderChild = useCallback(() => {
    return state.child.filter((e) => e.show);
  }, [state]);

  const renderControlContent = useCallback(() => {
    return (
      <Group value={state.selectKeys} dataSource={state.groupKeys} onChange={(value) => onSelectionchange(value)} />
    );
  }, [state, onSelectionchange]);

  return (
    <>
      {!state.hasAction && !state.isDetailPage && state.isInbound && <div style={{ height: '32px' }} />}
      <div className={styles.TableContainer}>
        {!state.isDetailPage && isTableSetting && state.isInbound && (
          <Button
            type="primary"
            size="medium"
            className={styles.SelectButton}
            id="colSettingBtn"
            onClick={() => setState({ visible: true })}
          >
            {$i18n.get({ id: 'ConfigurationColumn.four_px', dm: '配置列' })}
          </Button>
        )}
        <Table
          emptyContent={emptyContent}
          hasBorder={false}
          stickyHeader={stickyHeader}
          {...newprops}
          ref={ref}
          data-i18n-ignore-content
        >
          {renderChild()}
        </Table>
        <Dialog
          title={$i18n.get({ id: 'Select.four_px', dm: '请选择' })}
          visible={state.visible}
          onOk={() => doOk()}
          onCancel={() => setState({ visible: false, selectKeys: state.oldSelectKeys })}
          onClose={() => setState({ visible: false, selectKeys: state.oldSelectKeys })}
          style={{ width: '800px' }}
          className={styles.FpxTableBox}
        >
          {renderControlContent()}
        </Dialog>
      </div>
    </>
  );
};

export default FpxTable;
